export enum PaymentMethods {
  CREDITCARD = 1,
  BTC = 2,
  ETH = 3,
  LTC = 4,
  USDT = 5,
  USDC = 6,
}
